export default __webpack_public_path__ + "static/media/Group 901.7b8dc88e.svg";